import {animate, state, style, transition, trigger} from '@angular/animations';
import {MediaMatcher} from '@angular/cdk/layout';
import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {BehaviorSubject, firstValueFrom, Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AventiObject} from 'src/app/models/AventiObject';
import {Checklist} from 'src/app/models/Checklist';
import {ChecklistItem} from 'src/app/models/Checklistitem';
import {AventiFile} from 'src/app/models/File';
import {User} from 'src/app/models/User';
import {ChecklistService} from 'src/app/services/checklist.service';
import {CurrentpathService} from 'src/app/services/currentpath.service';
import {DateService} from 'src/app/services/date.service';
import {FileService} from 'src/app/services/file.service';
import {IdService} from 'src/app/services/id.service';
import {PopupService} from 'src/app/services/popup.service';
import {PrintChecklistService} from 'src/app/services/print-checklist.service';
import {SharedService} from 'src/app/services/shared.service';
import {SnackbarService} from 'src/app/services/snackbar.service';
import {environment} from 'src/environments/environment';
import _ from 'underscore';
import {ConfirmComponent} from '../../common/bottom-sheet/confirm/confirm.component';
import {ChecklistNavigationSheetComponent} from '../checklist-navigation-sheet/checklist-navigation-sheet.component';
import {CanDeactivateComponent} from '../../common/can-deactivate/can-deactivate.component';
import {AdminService} from 'src/app/services/admin.service';
import {ObjectStatus} from 'src/app/models/Status';
import {Project} from 'src/app/models/Project';
import {ObjectService} from 'src/app/services/object.service';
import {ProjectService} from 'src/app/services/project.service';
import {UserService} from 'src/app/services/user.service';
import {ReceiptformService} from 'src/app/services/receiptform.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {TableService} from 'src/app/services/prime/table.service';

@Component({
  animations: [
    trigger('animateDestroy', [
      state('void', style({opacity: '0'})),
      transition('* => void', animate('1000ms ease-in')),
    ]),
  ],
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.css'],
})
export class ChecklistComponent
  extends CanDeactivateComponent
  implements OnInit, AfterViewInit {
  checklistNotFound: boolean;
  checklist: Checklist;
  checklistTemp: Checklist;
  checklistitems: ChecklistItem[];
  checklistitemsTemp: ChecklistItem[];
  checklistfiles: AventiFile[];
  checklistitemfiles: AventiFile[];
  checklistpdfs: AventiFile[];
  object: AventiObject;
  isLoading = true;
  isAdmin = false;
  isSigning = false;
  isRemovingSignature = false;
  diffChecklistObject = false;
  sanitycheckNoPicture: boolean;
  sanitycheckPicturesCompletedCompressing = true;
  sanitycheckNoData: boolean;
  sanitycheckDeviations: boolean;
  sanitycheckNoValue: boolean;
  sanitycheckNoComment: boolean;
  sanitycheckNoValueComment: boolean;
  isReceiptform = false;
  loadingText: string[];
  loadingHeaderText = 'Åpner skjema...';
  isOnline: boolean;
  user: User;
  FormComment = new UntypedFormGroup({
    comment: new UntypedFormControl('', []),
  });
  mobileQuery: MediaQueryList;
  @ViewChild('scrollframe', {static: false}) scrollFrame: ElementRef;
  @ViewChild('bottomElement', {static: false}) bottomElement: ElementRef;
  @ViewChildren('checklistItemCard', {read: ElementRef}) checklistItemCards: QueryList<ElementRef>;
  statuses: ObjectStatus[] = [];
  statusNames: string[] = [];
  statusCount: Record<string, { count: number, checked: number, priority: number }>;
  groupOnce = true;
  project: Project;
  projectId: string;
  isFieldScan = false;
  hasScrolledToIncomplete = false;
  shouldScrollToIncomplete = false;
  activeItemIndex = -1;
  sortedChecklistItems: ChecklistItem[] = [];
  statusNavItems: Array<{ id: string, text: string, status: string, isComplete: boolean }> = [];
  showStatusNavigation = false;
  attributesToCheck = {
    name: 'Navn',
    tfmTag: 'TFM Tag',
    rdsTag: 'RDS Tag',
    desc: 'Beskrivelse',
    process: 'Prosess',
    profilenumber: 'Profilnummer',
  };
  checklistList: any[] = [];
  currentIndex: number = 0;
  private checklistListInitialized = false;
  private scrollTicking = false;
  private ngUnsubscribe = new Subject();
  private isBottomSheetOpen = false;
  private currentBottomSheetRef: any = null;
  // Scroll handler bound to document with capture phase to catch scroll from mat-sidenav-content
  private onScrollBound = this.onScroll.bind(this);

  constructor(
    private checklistservice: ChecklistService,
    private receiptformservice: ReceiptformService,
    private projectservice: ProjectService,
    private userservice: UserService,
    private bottomSheet: MatBottomSheet,
    private snackbarservice: SnackbarService,
    private idservice: IdService,
    private fileservice: FileService,
    private sharedservice: SharedService,
    media: MediaMatcher,
    private printchecklistservice: PrintChecklistService,
    private dateservice: DateService,
    private popupservice: PopupService,
    private currentpathservice: CurrentpathService,
    private adminservice: AdminService,
    private objectservice: ObjectService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private ptableService: TableService,
  ) {
    super();
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
    this.projectId = this.idservice.projectId();
    this.isFieldScan = this.idservice.isFieldScanPath();

    // Always reset the bottom sheet flag and reference on component creation
    this.isBottomSheetOpen = false;
    this.currentBottomSheetRef = null;

    // Read navigation state for checklistList and currentIndex
    const nav = this.router.getCurrentNavigation();
    if (nav?.extras.state) {
      this.checklistList = nav.extras.state['checklistList'] || [];
      this.currentIndex = nav.extras.state['currentIndex'] || 0;
      this.checklistListInitialized = this.checklistList.length > 0;
    } else if (history.state && (history.state.checklistList || history.state.currentIndex !== undefined)) {
      this.checklistList = history.state.checklistList || [];
      this.currentIndex = history.state.currentIndex || 0;
      this.checklistListInitialized = this.checklistList.length > 0;
    }
    // If no navigation state, will be initialized from sharedservice in ngOnInit
  }

  get comment() {
    return this.FormComment.get('comment');
  }

  canDeactivate(): boolean {
    return !this.checklist.generatingPDF;
  }

  async ngOnInit() {
    // Subscribe to route param changes
    this.route.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async params => {
      let checklistid: string;
      let objectid: string;
      this.isReceiptform = this.idservice.isReceiptformPath();
      if (this.isReceiptform) {
        checklistid = params.get('id') || this.idservice.receiptformId();
      } else {
        checklistid = params.get('id') || this.idservice.checklistId();
      }
      objectid = params.get('objectid') || this.idservice.objectId();
      await this.loadChecklistData(checklistid, objectid);
    });
  }

  async loadChecklistData(checklistid: string, objectid: string) {
    // Reset loading state to show spinner and trigger full reload
    this.isLoading = true;
    this.hasScrolledToIncomplete = false;
    this.shouldScrollToIncomplete = false;
    this.showStatusNavigation = false;
    this.activeItemIndex = -1;

    // Reset data arrays to ensure clean state
    this.checklistTemp = null;
    this.checklistitemsTemp = null;
    this.checklistfiles = null;
    this.checklistitemfiles = null;
    this.checklistpdfs = null;
    this.object = null;

    this.loadingText = [
      'Laster inn skjema...',
      'Laster inn punkter...',
      'Laster inn filer...',
    ];
    if (this.isFieldScan) {
      this.project = await firstValueFrom(this.projectservice.getFullProjectById(this.projectId));
      const firebaseUser = await firstValueFrom(this.userservice.getCurrentUser());
      this.userservice.getUser(firebaseUser?.uid)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((user) => {
          if (user !== null) {
            this.user = user;
            this.isAdmin = user.role.name === 'admin';
          }
        });
      this.isOnline = true;
    } else {
      this.sharedservice.project
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (project) => {
          if (project !== null) {
            this.project = project;
            await this.checkAll();
          }
        });
      this.sharedservice.user
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((user) => {
          if (user != null) {
            this.user = user;
            this.isAdmin = user.role.name === 'admin';
          }
        });
      this.sharedservice.online.subscribe(online => {
        this.isOnline = online;
      });
    }

    this.isReceiptform = this.idservice.isReceiptformPath();

    this.checklistservice.getChecklistItems(checklistid, this.isReceiptform)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (is) => {
        if (is !== null) {
          const items: ChecklistItem[] = [];
          is.forEach((item) => {
            if (item.checklistid === checklistid) {
              item.typename = item.type.name;
              items.push(item);
            }
          });
          const itemsbyname = _.sortBy(items, 'text');
          const checklistitems = _.sortBy(itemsbyname, 'typename');
          this.checklistitemsTemp = checklistitems;
          this.loadingText[1] = 'Punkter lastet inn';
          await this.checkAll();
        }
      });

    this.checklistservice.getAllChecklistItemFiles(checklistid)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (fs) => {
        if (fs !== null) {
          this.checklistitemfiles = _.sortBy(fs, 'timestamp');
          await this.checkAll();
        }
      });

    this.checklistservice.getChecklistFiles(checklistid)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (cfs) => {
        if (cfs !== null) {
          const files: AventiFile[] = [];
          cfs.forEach((file) => {
            if (!file.checklistitemid && file.checklistid === checklistid) {
              file.timestampstring = this.dateservice.dateAsYYYYMMDDHHNNSS(
                file.timestamp
              );
              files.push(file);
            }
          });
          this.checklistfiles = _.sortBy(files, 'timestamporiginal');
          this.loadingText[2] = 'Filer lastet inn';
          await this.checkAll();
        }
      });

    const projectId = this.idservice.projectId();
    const isFieldScan = this.idservice.isFieldScanPath();

    if (this.isReceiptform) {
      this.object = {};
      await this.checkAll();
    }
    if (isFieldScan) {
      const stateObject = null; // history.state.object;
      if (stateObject) {
        this.object = stateObject;
        await this.checkAll();
      } else {
        this.objectservice.getObjectById(projectId, objectid)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(async (object) => {
            if (object !== null) {
              if (object.id === objectid) {
                this.object = object;
                await this.checkAll();
              }
            }
          });
      }
    } else {
      this.sharedservice.objects
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (objects) => {
          if (objects !== null) {
            for (const object of objects) {
              if (object.id === objectid) {
                this.object = object;
                await this.checkAll();
              }
            }
          }
        });
    }

    this.checklistservice.getChecklistPdfs()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (pdfs) => {
        if (pdfs !== null) {
          this.checklistpdfs = pdfs;
          this.loadingText[3] = 'PDF-er lastet inn';
          await this.checkAll();
        }
      });

    if (isFieldScan) {
      const stateChecklist = null; // history.state.checklist;

      if (stateChecklist) {
        this.checklistTemp = stateChecklist;
        await this.checkAll();
      } else {
        let checklistObs: Observable<Checklist>;
        if (this.isReceiptform) {
          checklistObs = this.receiptformservice.getReceiptform();
        } else {
          checklistObs = this.checklistservice.getChecklistById(projectId, objectid, checklistid);
        }
        checklistObs.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (checklist) => {
          if (checklist !== null) {
            this.checklistTemp = checklist;
            await this.checkAll();
          } else {
            console.log('Ingen sjekkliste funnet...');
            this.failedToLoadChecklist();
          }
        });
      }
    } else {
      let checklistObs: BehaviorSubject<Checklist[]>;
      if (this.isReceiptform) {
        checklistObs = this.sharedservice.receiptforms;
      } else {
        checklistObs = this.sharedservice.checklists;
      }
      checklistObs.pipe(takeUntil(this.ngUnsubscribe)).subscribe((checklists) => {
        if (checklists !== null) {
          // Initialize checklistList from sharedservice if not already set from navigation state
          if (!this.isFieldScan && !this.checklistListInitialized && checklists.length > 0) {
            this.checklistList = checklists.map((cl, idx) => ({
              index: idx,
              id: cl.id,
              name: cl.name,
              tfmTag: cl.tfmTag,
              rdsTag: cl.rdsTag,
              objectId: cl.objectid,
              objectType: cl.type?.name,
              status: cl.statusHuman,
              severity: this.getSeverity(cl.status),
            }));
            // Find current index based on current checklist id
            const foundIndex = checklists.findIndex(c => c.id === checklistid);
            this.currentIndex = foundIndex !== -1 ? foundIndex : 0;
            this.checklistListInitialized = true;
          }

          new Promise(async (resolve) => {
            for (const checklist of checklists) {
              const index = checklists.indexOf(checklist);
              if (checklist?.id === checklistid) {
                resolve(true);
                this.checklistTemp = checklist;
                await this.checkAll();
              } else if (index === checklists.length - 1 && !this.checklistTemp) {
                resolve(false);
                console.log('Ingen sjekkliste funnet...');
              }
            }
          }).then((result) => {
            if (!result) {
              console.log('checklists failed to load');
              this.failedToLoadChecklist();
            }
          });
        }
      });
    }
  }

  getSeverity(status: string) {
    return this.ptableService.getChecklistStatusSeverity(status);
  }

  failedToLoadChecklist() {
    this.checklistNotFound = true;
  }

  async checkAll() {
    if (
      this.object &&
      this.checklistTemp &&
      this.checklistitemsTemp &&
      this.checklistfiles &&
      this.checklistpdfs &&
      this.project
    ) {
      const wasLoading = this.isLoading;

      this.checklistTemp = this.prepareChecklist();

      if (wasLoading) {
        const check = await this.checkAndGroupItems();
        this.checklistTemp = check ?? this.checklistTemp;
      } else {
        // After initial load, only update status navigation with fresh data from checklistitemsTemp
        this.updateStatusNavigationFromTemp();
      }

      this.checklist = this.checklistTemp;
      this.loadingText[0] = 'Skjema lastet inn';

      this.diffChecklistObject = false;
      if (!this.isReceiptform) {
        this.diffChecklistObject = Object.keys(this.attributesToCheck).some(key => {
          const checkO = this.object[key] || '';
          const checkC = this.checklist[key] || '';
          return checkO !== checkC;
        });
      }
      this.isLoading = false;

      // Trigger scroll check after view updates
      if (!this.hasScrolledToIncomplete && !this.checklist.isSigned) {
        this.shouldScrollToIncomplete = true;
      } else if (this.checklist.isSigned) {
        // If signed, just show the navigation immediately
        setTimeout(() => {
          this.showStatusNavigation = true;
        }, 500);
      }

      // Only rebuild navigation on initial load; subsequent updates use updateStatusNavigationFromTemp
      if (wasLoading) {
        this.updateSortedChecklistItems();
        this.updateStatusNavigation();
      }
      this.cdr.detectChanges();
    }
    this.validateForm();
  }

  ngAfterViewInit() {
    // Add scroll listener to document with capture phase to catch scroll from mat-sidenav-content
    document.addEventListener('scroll', this.onScrollBound, true);

    // Subscribe to changes in ViewChildren to know when cards are rendered
    this.checklistItemCards.changes
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        if (this.shouldScrollToIncomplete && !this.hasScrolledToIncomplete) {
          setTimeout(() => this.scrollToFirstIncomplete(), 500);
        }
      });

    // Also try after a longer delay to ensure rendering is complete
    setTimeout(() => {
      if (this.shouldScrollToIncomplete && this.checklistItemCards && this.checklistItemCards.length > 0) {
        if (!this.hasScrolledToIncomplete) {
          this.scrollToFirstIncomplete();
        }
      }
    }, 1000);

    // Manually trigger once after initial load
    setTimeout(() => {
      this.updateActiveItem();
    }, 2000);

    // Interval for status updates from other users/DB changes
    // Active item tracking is handled by scroll event with requestAnimationFrame
    setInterval(() => {
      if (this.checklistitemsTemp?.length > 0) {
        this.updateStatusNavigationFromTemp();
      }
    }, 500);
  }

  updateStatusNavigation() {
    // Don't update if data isn't ready yet - preserve existing statusNavItems
    if (!this.sortedChecklistItems || this.sortedChecklistItems.length === 0) {
      return;
    }

    const navItems: Array<{ id: string, text: string, status: string, isComplete: boolean }> = [];

    // Use sortedChecklistItems directly to ensure same order
    this.sortedChecklistItems.forEach(item => {
      navItems.push({
        id: item.id,
        text: item.text,
        status: item.status || '',
        isComplete: this.isItemComplete(item)
      });
    });

    // Only update if we built a valid list - prevents clearing on temporary empty states
    if (navItems.length > 0) {
      this.statusNavItems = [...navItems];
      this.cdr.detectChanges();
    }
  }

  updateStatusNavigationFromTemp() {
    // Update statusNavItems using fresh data from checklistitemsTemp
    // without rebuilding sortedChecklistItems to avoid flickering
    if (!this.statusNavItems || this.statusNavItems.length === 0 || !this.checklistitemsTemp) {
      return;
    }

    let hasChanges = false;

    // Create new array with updated values to trigger change detection
    const updatedNavItems = this.statusNavItems.map(navItem => {
      const freshItem = this.checklistitemsTemp.find(item => item.id === navItem.id);
      if (freshItem) {
        const newIsComplete = this.isItemComplete(freshItem);
        const newStatus = freshItem.status || '';
        if (navItem.isComplete !== newIsComplete || navItem.status !== newStatus) {
          hasChanges = true;
          return {
            ...navItem,
            isComplete: newIsComplete,
            status: newStatus
          };
        }
      }
      return navItem;
    });

    if (hasChanges) {
      this.statusNavItems = updatedNavItems;
      this.cdr.detectChanges();
    }
  }

  getNavItemById(id: string): ChecklistItem | undefined {
    return this.sortedChecklistItems?.find(item => item.id === id);
  }

  getSortedChecklistItems() {
    if (!this.checklistitemsTemp) {
      return [];
    }

    // If using status levels, sort by status priority (same as main checklist)
    if (this.project?.useStatusLevel && this.statuses?.length > 0) {
      const sorted: any[] = [];

      for (const status of this.statuses) {
        for (const item of this.checklistitemsTemp) {
          const matchesStatus = this.isReceiptform ||
            status?.id === 'all' ||
            item.statusLevel?.name === status?.name ||
            (status?.name === 'Uten statusnivå' && (!item.statusLevel || !this.statusNames.includes(item.statusLevel?.name)));

          if (matchesStatus && !sorted.find(n => n.id === item.id)) {
            sorted.push(item);
          }
        }
      }

      // Add items without statusLevel if "Uten statusnivå" isn't in the list
      if (!this.statuses.find(s => s?.name === 'Uten statusnivå')) {
        for (const item of this.checklistitemsTemp) {
          if ((!item.statusLevel || !this.statusNames.includes(item.statusLevel?.name)) &&
            !sorted.find(n => n.id === item.id)) {
            sorted.push(item);
          }
        }
      }

      return sorted;
    } else {
      // If not using status levels, use original order
      return [...this.checklistitemsTemp];
    }
  }

  scrollToFirstIncomplete() {
    if (this.hasScrolledToIncomplete || !this.checklistitems || !this.checklistItemCards) {
      return;
    }

    // Find first incomplete checklist item respecting status priority
    let firstIncomplete: ChecklistItem | undefined;

    if (this.project?.useStatusLevel && this.statuses?.length > 0) {
      // If using status levels, find first incomplete item in priority order
      for (const status of this.statuses) {
        const incompleteInStatus = this.checklistitems.find(item => {
          const matchesStatus = this.isReceiptform ||
            (item.statusLevel?.name === status?.name ||
              (status?.name === 'Uten statusnivå' && !this.statusNames.includes(item.statusLevel?.name)));
          return matchesStatus && this.isItemIncomplete(item);
        });
        if (incompleteInStatus) {
          firstIncomplete = incompleteInStatus;
          break;
        }
      }
    } else {
      // If not using status levels, just find first incomplete
      firstIncomplete = this.checklistitems.find(item => {
        return this.isItemIncomplete(item);
      });
    }

    if (firstIncomplete) {
      const cards = this.checklistItemCards.toArray();

      // Find the card by checking the parent div's data-item-id attribute
      const targetCard = cards.find(card => {
        const parentDiv = card?.nativeElement?.parentElement;
        return parentDiv?.getAttribute('data-item-id') === firstIncomplete.id;
      });

      if (targetCard?.nativeElement) {
        targetCard.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        // Add highlight animation
        setTimeout(() => {
          targetCard.nativeElement.classList.add('scroll-highlight');
          // Fade in status navigation
          this.showStatusNavigation = true;
        }, 250);

        // Remove the class after animation completes
        setTimeout(() => {
          targetCard.nativeElement.classList.remove('scroll-highlight');
        }, 2500);

        this.hasScrolledToIncomplete = true;
      }
    } else if (!firstIncomplete) {
      // All items are complete, scroll to bottom
      setTimeout(() => {
        if (this.bottomElement?.nativeElement) {
          this.bottomElement.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
          });
          this.hasScrolledToIncomplete = true;
          // Fade in status navigation
          this.showStatusNavigation = true;
        }
      }, 300);
    }
  }

  isItemComplete(item: ChecklistItem): boolean {
    return !this.isItemIncomplete(item);
  }

  scrollToItem(itemId: string) {
    const cards = this.checklistItemCards?.toArray();
    if (!cards) {
      return;
    }

    const targetCard = cards.find(card => {
      const parentDiv = card?.nativeElement?.parentElement;
      return parentDiv?.getAttribute('data-item-id') === itemId;
    });

    if (targetCard?.nativeElement) {
      targetCard.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      // Add highlight animation
      targetCard.nativeElement.classList.add('scroll-highlight');
      setTimeout(() => {
        targetCard.nativeElement.classList.remove('scroll-highlight');
      }, 2000);
    }
  }

  updateActiveItem() {
    if (!this.statusNavItems || !this.checklistItemCards) {
      return;
    }

    const cards = this.checklistItemCards.toArray();
    if (cards.length === 0) {
      return;
    }

    const viewportCenter = window.innerHeight / 2;
    let closestIndex = -1;
    let closestDistance = Infinity;

    cards.forEach((card) => {
      const element = card?.nativeElement;
      if (!element) {
        return;
      }

      const rect = element.getBoundingClientRect();

      // Skip if element is far off-screen (optimization)
      if (rect.bottom < -window.innerHeight || rect.top > window.innerHeight * 2) {
        return;
      }

      const elementCenter = rect.top + rect.height / 2;
      const distance = Math.abs(elementCenter - viewportCenter);

      if (distance < closestDistance) {
        closestDistance = distance;

        // Find the corresponding index in statusNavItems
        const itemId = element.parentElement?.getAttribute('data-item-id');
        if (itemId) {
          const navIndex = this.statusNavItems.findIndex(item => item.id === itemId);
          if (navIndex !== -1) {
            closestIndex = navIndex;
          }
        }
      }
    });

    // Only update if there's actually a visible card and index changed
    if (closestDistance < window.innerHeight && closestIndex !== -1 && closestIndex !== this.activeItemIndex) {
      this.activeItemIndex = closestIndex;
    }
  }

  ngOnDestroy() {
    // Close any open bottom sheets before destroying the component
    if (this.isBottomSheetOpen && this.currentBottomSheetRef) {
      try {
        this.currentBottomSheetRef.dismiss();
      } catch (error) {
        console.error('Error dismissing bottom sheet in ngOnDestroy:', error);
      }
      this.currentBottomSheetRef = null;
      this.isBottomSheetOpen = false;
    }

    // Also try to dismiss at service level as a safety measure
    try {
      this.bottomSheet.dismiss();
    } catch (error) {
      // Ignore errors if no bottom sheet is open
    }

    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
    document.removeEventListener('scroll', this.onScrollBound, true);
  }

  signChecklistConfirm(): void {
    let text = 'Signér sjekkliste: ';
    let title = 'Signere?';
    if (this.checklist.receiptform) {
      text = 'Signér mottaksskjema: ';
    }
    text += this.checklist.name;
    if (this.sanitycheckDeviations) {
      text += ' med avvik';
      title = 'Signere med avvik?';
    }

    const sheet = this.bottomSheet.open(ConfirmComponent, {
      backdropClass: 'blur-dialog-backdrop',
      data: {
        title,
        text,
        yes: {
          name: 'Ja',
          icon: 'edit',
        },
        no: {
          name: 'Nei',
          icon: 'close',
        },
      },
    });
    sheet
      .afterDismissed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (confirm) => {
        if (confirm) {
          this.checklistservice.updateChecklistSignature(this.checklist);
          if (this.isOnline) {
            await this.generatePDF(this.checklist);
          }
        }
      });
  }

  deleteChecklistConfirm(): void {
    let text = 'Slette sjekkliste: ';
    if (this.checklist.receiptform) {
      text = 'Slette mottaksskjema: ';
    }
    const sheet = this.bottomSheet.open(ConfirmComponent, {
      backdropClass: 'blur-dialog-backdrop',
      data: {
        title: 'Er du sikker?',
        text: text + this.checklist.name,
        yes: {
          name: 'Ja',
          icon: 'delete',
        },
        no: {
          name: 'Nei',
          icon: 'close',
        },
      },
    });
    sheet
      .afterDismissed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((confirm) => {
        if (confirm) {
          this.checklistservice
            .deleteChecklist(this.checklist)
            .then(() => {
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
  }

  editChecklistStatus(): void {
    const sheet = this.bottomSheet.open(ConfirmComponent, {
      backdropClass: 'blur-dialog-backdrop',
      data: {
        title: 'OBS! Dette fjerner også PDF tilknyttet sjekklisten!',
        text: 'Fjerne signering for: ' + this.checklist.name,
        yes: {
          name: 'Ja',
          icon: 'directions_off',
        },
        no: {
          name: 'Nei',
          icon: 'close',
        },
      },
    });
    sheet
      .afterDismissed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (confirm) => {
        if (confirm) {
          this.isRemovingSignature = true;
          await this.checklistservice
            .updateChecklistStatus('finished', this.checklist)
            .then(async () => {
              console.log('Checkliststatus changed to finished...');
              if (
                this.checklist.pdfexports &&
                this.checklist.pdfexports.length > 0
              ) {
                for (const pdf of this.checklist.pdfexports) {
                  await this.fileservice.deleteFile(pdf, true);
                }
              }
              await this.checklistservice.updateChecklistGeneratingPDF(
                false,
                this.checklist
              );
              this.snackbarservice.openSnackBar(
                'Sjekklistesignatur fjernet. Sjekkliste kan nå redigeres.',
                ''
              );
              await this.checkAll();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
  }

  openDialogPdfPreview(
    file: AventiFile,
    checklist: Checklist,
    locked: boolean = false
  ) {
    this.popupservice.openDialogFilePreview([file], 0, locked, checklist);
  }

  async generatePDF(checklist: Checklist) {
    await this.printchecklistservice.sendChecklistToPrint(checklist);
  }

  updateComment(comment) {
    this.checklistservice.updateChecklistComment(this.checklist, comment);
  }

  copyFileLocation() {
    this.currentpathservice.copyFilePathToClipboard();
  }

  updateChecklistFromObject() {
    const checklist = {};
    const object = this.object;
    const sheet = this.bottomSheet.open(ConfirmComponent, {
      backdropClass: 'blur-dialog-backdrop',
      data: {
        title: 'Oppdatere sjekklistedata',
        text: 'Dette oppdaterer sjekklistedata med data fra objekt. Er du sikker?',
        compareTitles: {
          id: 'Attributt',
          before: 'Objektdata',
          after: 'Sjekklistedata',
        },
        compare: Object.entries(this.attributesToCheck).map(([key, label]) => ({
          id: label,
          before: this.object[key] || '',
          after: this.checklist[key] || '',
        })),
        yes: {
          name: 'Ja',
          icon: 'check',
        },
        no: {
          name: 'Nei',
          icon: 'close',
        },
      },
    });
    sheet
      .afterDismissed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (confirm) => {
        if (confirm) {
          Object.keys(this.attributesToCheck).forEach((key) => {
            checklist[key] = object[key] || '';
          });
          await this.checklistservice.updateChecklist(object.id, checklist);
          this.snackbarservice.openSnackBar('Sjekklistedata oppdatert', '');
        }
      });
  }

  updateSortedChecklistItems() {
    if (!this.checklistitems || !this.statuses) {
      this.sortedChecklistItems = [];
      return;
    }

    const sorted: ChecklistItem[] = [];

    // If using status levels, sort by status priority
    if (this.project?.useStatusLevel && this.statuses?.length > 0) {
      for (const status of this.statuses) {
        for (const item of this.checklistitems) {
          const matchesStatus = this.isReceiptform ||
            status?.id === 'all' ||
            item.statusLevel?.name === status?.name ||
            (status?.name === 'Uten statusnivå' && (!item.statusLevel || !this.statusNames.includes(item.statusLevel?.name)));

          if (matchesStatus && !sorted.includes(item)) {
            // Add computed properties for Angular to track
            const isComplete = this.isItemComplete(item);
            (item as any)._isComplete = isComplete;
            (item as any)._timestamp = Date.now();
            sorted.push(item);
          }
        }
      }
    } else {
      // If not using status levels, use original order
      this.checklistitems.forEach(item => {
        const isComplete = this.isItemComplete(item);
        (item as any)._isComplete = isComplete;
        (item as any)._timestamp = Date.now();
      });
      sorted.push(...this.checklistitems);
    }

    // Create new array reference to trigger change detection
    this.sortedChecklistItems = [...sorted];
  }

  trackByItemId(_index: number, item: ChecklistItem): string {
    return item.id;
  }

  trackByNavItem(_index: number, navItem: { id: string, isComplete: boolean, status: string }): string {
    return `${navItem.id}-${navItem.isComplete}-${navItem.status}`;
  }

  async goToPreviousChecklist() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      await this.navigateToChecklist(this.currentIndex);
    }
  }

  async goToNextChecklist() {
    if (this.currentIndex < this.checklistList.length - 1) {
      this.currentIndex++;
      await this.navigateToChecklist(this.currentIndex);
    }
  }

  async goToSelectedChecklist() {
    await this.navigateToChecklist(this.currentIndex);
  }

  openChecklistNavigation() {
    // If a bottom sheet is already open, just ignore the click
    if (this.isBottomSheetOpen) {
      return;
    }

    if (!this.checklistList || this.checklistList.length === 0) {
      return;
    }

    try {
      this.isBottomSheetOpen = true;

      const sheet = this.bottomSheet.open(ChecklistNavigationSheetComponent, {
        data: {
          checklistList: this.checklistList,
          currentIndex: this.currentIndex
        },
        backdropClass: 'blur-dialog-backdrop',
        panelClass: 'checklist-navigation-bottom-sheet',
        disableClose: false,
        hasBackdrop: true,
        autoFocus: true
      });

      this.currentBottomSheetRef = sheet;

      sheet.afterDismissed().subscribe(async (selectedIndex: number) => {
        this.isBottomSheetOpen = false;
        this.currentBottomSheetRef = null;

        if (selectedIndex !== undefined && selectedIndex !== null && selectedIndex !== this.currentIndex) {
          this.currentIndex = selectedIndex;

          // Ensure bottom sheet is fully closed before navigating
          await new Promise(resolve => setTimeout(resolve, 100));

          await this.navigateToChecklist(selectedIndex);
        }
      });
    } catch (error) {
      console.error('Error opening bottom sheet:', error);
      this.isBottomSheetOpen = false;
      this.currentBottomSheetRef = null;
    }
  }

  async navigateToChecklist(index: number) {
    const entry = this.checklistList[index];
    if (!entry) {
      return;
    }

    // Build the URL path
    let path: string;
    if (this.isReceiptform) {
      path = `/p/${this.projectId}/mt/${entry.id}`;
    } else {
      path = `/p/${this.projectId}/o/${entry.objectId}/s/${entry.id}`;
    }

    // Use location.replaceState to update URL without adding to browser history
    // This way location.back() will go to the page before the checklist navigation started
    this.location.replaceState(path, '', {
      checklistList: this.checklistList,
      currentIndex: index
    });

    // Manually trigger route change by navigating with skipLocationChange
    await this.router.navigate([path], {
      state: {
        checklistList: this.checklistList,
        currentIndex: index
      },
      skipLocationChange: true
    });
  }

  private onScroll() {
    // Use requestAnimationFrame to throttle scroll updates for smooth 60fps performance
    if (!this.scrollTicking) {
      this.scrollTicking = true;
      requestAnimationFrame(() => {
        this.updateActiveItem();
        this.scrollTicking = false;
      });
    }
  }

  private isItemIncomplete(item: ChecklistItem): boolean {
    switch (item.type?.name) {
    case 'Avkrysning':
      // Incomplete if no status selected
      if (!item.status) {
        return true;
      }
      // Incomplete if deviation without comment
      if (item.status === 'deviation' && (!item.comment || item.comment.length === 0)) {
        return true;
      }
      return false;
    case 'Kommentar':
      // Incomplete if no comment
      return !item.comment || item.comment.length === 0;
    case 'Måling':
      // Incomplete if no value or no value comment
      if (!item.value || item.value.length === 0) {
        return true;
      }
      if (!item.valuecomment || item.valuecomment.length === 0) {
        return true;
      }
      return false;
    case 'Ekstern dokumentasjon':
      return false;
    default:
      return false;
    }
  }

  private validateChecklistItem(item: ChecklistItem): {
    deviations: number;
    deviationsSigned: number;
    noComment: number;
    noData: number;
    noValue: number;
    noValueComment: number;
  } {
    const result = {
      deviations: 0,
      deviationsSigned: 0,
      noComment: 0,
      noData: 0,
      noValue: 0,
      noValueComment: 0
    };

    switch (item.type?.name) {
    case 'Avkrysning':
      if (item.status === 'deviation') {
        result.deviations++;
        if (item.deviationSignedBy) {
          result.deviationsSigned++;
        }
        if (!item.comment || item.comment?.length === 0) {
          result.noComment++;
        }
      }
      if (!item.status) {
        result.noData++;
      }
      break;
    case 'Kommentar':
      if (!item.comment || item.comment?.length === 0) {
        result.noComment++;
      }
      break;
    case 'Måling':
      if (!item.value || item.value?.length === 0) {
        result.noValue++;
      }
      if (!item.valuecomment || item.valuecomment?.length === 0) {
        result.noValueComment++;
      }
      break;
    case 'Ekstern dokumentasjon':
      break;
    default:
      break;
    }

    return result;
  }

  private validateForm() {
    if (
      this.checklistitemsTemp &&
      this.checklist &&
      this.checklistfiles &&
      this.checklistitemfiles
    ) {
      let numberOfDeviations = 0;
      let numberOfDeviationsSigned = 0;
      let numberOfNoValue = 0;
      let numberOfNoComment = 0;
      let numberOfNoValueComment = 0;
      let numberOfNoData = 0;

      this.checklistitemsTemp.forEach((item) => {
        const validation = this.validateChecklistItem(item);
        numberOfDeviations += validation.deviations;
        numberOfDeviationsSigned += validation.deviationsSigned;
        numberOfNoComment += validation.noComment;
        numberOfNoData += validation.noData;
        numberOfNoValue += validation.noValue;
        numberOfNoValueComment += validation.noValueComment;
      });
      this.checklist.numberOfDeviations = numberOfDeviations;
      this.checklist.numberOfDeviationsSigned = numberOfDeviationsSigned;
      this.checklist.numberOfNoComment = numberOfNoComment;
      this.checklist.numberOfNoData = numberOfNoData;
      this.checklist.numberOfNoValue = numberOfNoValue;
      this.checklist.numberOfNoValueComment = numberOfNoValueComment;
      this.sanitycheckDeviations = numberOfDeviations > 0 &&
        numberOfDeviationsSigned !== numberOfDeviations;
      this.sanitycheckNoValue = numberOfNoValue > 0;
      this.sanitycheckNoComment = numberOfNoComment > 0;
      this.sanitycheckNoValueComment = numberOfNoValueComment > 0;
      this.sanitycheckNoData = numberOfNoData > 0;
      this.sanitycheckNoPicture = this.checklistfiles.length <= 0;

      let checklistFilesCompletedCompressing = true;
      this.checklistfiles.forEach((file) => {
        if (file.downloadurl200 === undefined && file.type?.startsWith('image/')) {
          checklistFilesCompletedCompressing = false;
          console.log('File not yet compressed:', file);
        }
      });

      let checklistItemFilesCompletedCompressing = true;
      this.checklistitemfiles.forEach((file) => {
        if (file.downloadurl200 === undefined && file.type?.startsWith('image/')) {
          checklistItemFilesCompletedCompressing = false;
          console.log('Checklist item file not yet compressed:', file);
        }
      });
      this.sanitycheckPicturesCompletedCompressing = checklistFilesCompletedCompressing && checklistItemFilesCompletedCompressing;
    }
  }

  private async checkAndGroupItems() {
    if (
      !this.checklistTemp || !this.checklistitemsTemp || !this.object || !this.project) {
      return null;
    }
    const allStatuses = await firstValueFrom(this.adminservice.getObjectStatuses());
    const allAdminChecklistitems = await firstValueFrom(this.adminservice.getAllChecklistitemsObs());
    const {
      statuses,
      statusNames,
      statusCount,
      adminChecklistItems
    } = this.checklistservice.groupChecklistItems(
      this.object,
      this.checklistTemp,
      this.isReceiptform,
      this.project.useStatusLevel,
      allStatuses,
      allAdminChecklistitems,
      this.checklistitemsTemp
    );

    this.checklistitems = this.checklistitemsTemp.map(cl => {
        cl.statusLevel = adminChecklistItems?.find(acl => acl?.text === cl?.text)?.statusLevel;
        return cl;
      }
    );

    // Sort statuses by priority before assigning
    const sortedStatuses = _.sortBy(statuses, 'priority');
    if (JSON.stringify(_.sortBy(this.statuses, 'priority')) !== JSON.stringify(sortedStatuses)) {
      this.statuses = sortedStatuses;
    }

    this.statusNames = statusNames;
    this.statusCount = statusCount;

    // Create sorted array matching visual order
    this.updateSortedChecklistItems();

    // Initialize status navigation
    this.updateStatusNavigation();

    return this.checklistTemp;
  }

  private prepareChecklist() {
    if (this.checklistTemp && this.checklistpdfs) {
      this.checklistTemp = this.sharedservice.prepareChecklistsChecklist(this.checklistTemp);
      this.checklistTemp = this.sharedservice.prepareChecklistsChecklistPdfs(this.checklistTemp, this.checklistpdfs);
      if (!this.checklistTemp.generatingPDFchecklist) {
        this.isSigning = false;
      }
      if (
        !this.checklistTemp.pdfexports ||
        this.checklistTemp.pdfexports.length === 0
      ) {
        this.isRemovingSignature = false;
      }
      if (this.isReceiptform) {
        this.checklistTemp.path =
          'projects/' +
          this.projectId +
          '/receiptforms/' +
          this.checklistTemp.id;
      } else {
        this.checklistTemp.path =
          'projects/' +
          this.projectId +
          '/objects/' +
          this.object.id +
          '/checklists/' +
          this.checklistTemp.id;
      }

      this.checklistTemp.comment = this.checklistTemp.comment ?? '';
    }
    return this.checklistTemp;
  }

}
